"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryDay = exports.DeliveryOptionsEnum = void 0;
var DeliveryOptionsEnum;
(function (DeliveryOptionsEnum) {
    DeliveryOptionsEnum["COLLECT_STORE"] = "COLLECT_STORE";
    DeliveryOptionsEnum["COLLECT_HQ"] = "COLLECT_HQ";
    DeliveryOptionsEnum["HOME_DELIVERY"] = "HOME_DELIVERY";
    DeliveryOptionsEnum["NEXT_DAY"] = "NEXT_DAY";
    DeliveryOptionsEnum["NAMED_DAY"] = "NAMED_DAY";
    DeliveryOptionsEnum["PICKUP_POINT"] = "PICKUP_POINT";
})(DeliveryOptionsEnum || (exports.DeliveryOptionsEnum = DeliveryOptionsEnum = {}));
exports.deliveryDay = {
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7,
};
//# sourceMappingURL=DeliveryPromise.js.map